import React, { useState, useEffect } from "react";
import { Modal, Button, Steps, Typography } from "antd";
import { InfoCircleFilled } from "@ant-design/icons";
import { useSelector } from "react-redux";

const { Text } = Typography;

/**
 * Component GuideBoSungHoSo (Hướng dẫn quy trình bổ sung hồ sơ)
 *
 * @param {boolean} isBoSung - Trạng thái hồ sơ có đang yêu cầu bổ sung hay không
 * @param {string} title - Tiêu đề Modal hướng dẫn
 * @param {Function} onClose - Callback khi người dùng bấm Đã hiểu / Đóng
 */
const GuideBoSungHoSo = ({
  isBoSung = false,
  title = "Hướng dẫn bổ sung hồ sơ",
  onClose,
}) => {
  const [open, setOpen] = useState(false);
  const General = useSelector((state) => state.General);
  const ShowUC = General?.ShowUC || false;

  useEffect(() => {
    if (isBoSung) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [isBoSung]);

  const handleClose = () => {
    setOpen(false);
    if (typeof onClose === "function") {
      onClose();
    }
  };

  if (!ShowUC) return null;
  if (!isBoSung) return null;

  return (
    <Modal
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "#1890ff",
          }}
        >
          <InfoCircleFilled style={{ fontSize: "20px" }} />
          <span
            style={{ fontSize: "16px", fontWeight: "600", color: "#262626" }}
          >
            {title}
          </span>
        </div>
      }
      open={open}
      onCancel={handleClose}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={handleClose}
          style={{ fontWeight: 600 }}
        >
          Tôi đã hiểu và bắt đầu bổ sung
        </Button>,
      ]}
      width={600}
      centered
      maskClosable={false}
    >
      <div style={{ padding: "10px 0", fontSize: "14px", color: "#444" }}>
        <p style={{ marginBottom: "20px" }}>
          Hồ sơ của bạn đang trong trạng thái{" "}
          <strong style={{ color: "#cf1322" }}>Yêu cầu bổ sung</strong> từ cán
          bộ xử lý. Để hồ sơ được tiếp tục giải quyết, vui lòng thực hiện các
          bước sau:
        </p>
        <Steps
          direction="vertical"
          size="small"
          current={0}
          items={[
            {
              title: (
                <span style={{ fontWeight: 600 }}>Xem nội dung yêu cầu</span>
              ),
              description:
                "Đọc kỹ phần Lịch sử / Ghi chú của cán bộ để biết chính xác những giấy tờ hoặc thông tin nào cần bổ sung.",
            },
            {
              title: <span style={{ fontWeight: 600 }}>Cập nhật giấy tờ</span>,
              description:
                "Tải lên các tệp đính kèm tương ứng (bản chụp/scan rõ nét) tại mục Thành phần hồ sơ đính kèm.",
            },
            {
              title: <span style={{ fontWeight: 600 }}>Xác nhận nộp</span>,
              description:
                "Sau khi cập nhật đầy đủ, bắt buộc bấm nút Xác nhận nộp hồ sơ ở cuối trang để gửi lại hồ sơ cho cán bộ xử lý.",
            },
          ]}
        />
        <div
          style={{
            marginTop: "24px",
            padding: "12px",
            background: "#fffbe6",
            border: "1px solid #ffe58f",
            borderRadius: "8px",
          }}
        >
          <Text type="warning" style={{ fontSize: "13px" }}>
            <strong>Lưu ý quan trọng:</strong> Nếu quá thời hạn yêu cầu bổ sung
            mà bạn không thực hiện, hồ sơ có thể bị tự động từ chối hoặc hủy bỏ
            theo quy định.
          </Text>
        </div>
      </div>
    </Modal>
  );
};

export default GuideBoSungHoSo;
